/**
 * Available platforms for Capacitor
 */
export enum CapacitorPlatform {
  ANDROID = 'android',
  IOS = 'ios',
  WEB = 'web',
}
